import { useState, useEffect } from 'react';
import Footer from '../../components/Footer/Footer';
import HeaderMain from '../../components/HeaderMain/HeaderMain';
import HeaderMobile from '../../components/HeaderMobile/HeaderMobile';
import { useTranslation } from 'react-i18next';

function Terms() {
  const [selectedTab, setSelectedTab] = useState("unauthorizedEmailCollection");
  const [isMobile, setIsMobile] = useState(false);
  const { t, i18n } = useTranslation();
  
  useEffect(() => {
    const savedLanguage = localStorage.getItem('selectedLanguage') || 'en';

    if (i18n.language !== savedLanguage) {
      i18n.changeLanguage(savedLanguage);
    }
    
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    handleResize();
    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [i18n]);
  
  return (
    <>
      {isMobile ? (
        <HeaderMobile />
      ) : (
      <HeaderMain 
        selectedTab={selectedTab}
        onTabChange={setSelectedTab}
      />  
      )}
      
      <div style={{ padding: '64px 0' }}>
        <h3
          style={{
            color: '#000',
            fontSize: '29px',
            letterSpacing: '-1px',
            textAlign: 'center',
            fontWeight: '600',
          }}
        >
          User guide
        </h3>
        <div style={{ padding: '64px 0' }}>
        <h3
          style={{
            color: '#000',
            fontSize: '29px',
            letterSpacing: '-1px',
            textAlign: 'center',
            fontWeight: '600',
            paddingBottom: '32px',
          }}
        >
          Rejection of Unauthorized Collection of Email
        </h3>
        <div
          dangerouslySetInnerHTML={{
            __html: `<div class="editor">
Please be advised that the email addresses posted on this website are not to be collected without authorization using email collection programs or other technical devices. Violation of this may result in criminal penalties under the Information and Communication Network Act.<br><p>
Act on the Use and Protection of Information Communication Networks and the Promotion of Information Processing (Partially amended on December 18, 2002, Law No. 0697)</p><br><br>
    
    <p style="font-size:15px; color:#000; letter-spacing:-0.5px; font-weight:600;">Article 50.2 (Prohibition of unauthorized collection of e-mail addresses, etc.)</p><br>
    <p>• No one shall sell or distribute e-mail addresses collected in violation of the provisions of Paragraph 1.<br>
    • No one shall sell or distribute e-mail addresses collected in violation of the provisions of Paragraph <br>
    • No one shall use an e-mail address for information transmission knowing that it is an e-mail address prohibited from collection, sale, and distribution under the provisions of paragraphs 1 and 2.</p><br><br>
    
    <p style="font-size:15px; color:#000; letter-spacing:-0.5px; font-weight:600;">
    Article 65.2 (Penalties) Those falling under subparagraph 1 of the following provisions shall be subject to a fine not exceeding 10 million won.</p><br>
    <p>• Article 65.2 (Penalties) Those falling under subparagraph 1 of the following provisions shall be subject to a fine not exceeding 10 million won.<br>
    • Those who violate the provisions of Article 50, Paragraph 4 by taking technical measures.<br>
    • Those who violate the provisions of Article 50, Paragraph 6 by transmitting advertising information for profit.<br>
    • Those who violate the provisions of Article 50, Paragraph 2 by collecting, selling, distributing, or using email addresses for information transmission.</p>
    
    <br><br>
    <p style="font-size:15px; color:#000; letter-spacing:-0.5px; font-weight:600;"><span style="font-size: 11pt;">
    Post Date:&nbsp;</span><u style="font-size: 12px;"><a href="#none" class="js_insert_text" style="font-size: 12px;"><span style="font-size: 11pt;">
    November 4, 2022, 16:33:22</span></a></u></p>			</div>`,
          }}
        ></div>
      </div>
      </div>
      <Footer />
    </>
  );
}
export default Terms;
